import { render, staticRenderFns } from "./DislikedIngredients.vue?vue&type=template&id=3793e6b4&scoped=true"
import script from "./DislikedIngredients.vue?vue&type=script&lang=js"
export * from "./DislikedIngredients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3793e6b4",
  null
  
)

export default component.exports